import React, { useMemo } from "react";
import { Box } from "@mui/material";
import { FONT_SIZE } from "../../../../constants/fontSizes";
import { compareByName, compareSkillLabels } from "../../../utils/sortSkills";

/**
 * 使用技術（スキル）
 * 表示ルール：
 * ■ カテゴリー
 * メインスキル
 * ・サブスキル
 * 
 * ABC順
 */
export default function SkillSheetMainSkill({ skillSections }) {
  const visibleSections = useMemo(() => {
    const normalizedSections = Array.isArray(skillSections) ? skillSections : [];

    const sortedSections = normalizedSections.map((section) => {
      const normalizedSkills = Array.isArray(section.skills) ? section.skills : [];

      const sortedSkills = normalizedSkills
        .filter(
          (skill) =>
            typeof skill.name === "string" && skill.name.trim() !== ""
      )
      .map((skill) => ({
        ...skill,
        subSkills: Array.isArray(skill.subSkills)
          ? [...skill.subSkills].sort(compareSkillLabels)
          : [],
      }))
      .sort(compareByName);
      return {
        ...section,
        skills: sortedSkills,
      };
    });

    return sortedSections.filter(
      (section) => Array.isArray(section.skills) && section.skills.length > 0,
    );
  }, [skillSections]);

  if (visibleSections.length === 0) {
    return <Box sx={{ p: 0.5, fontSize: FONT_SIZE.XXS }}>-</Box>;
  }

  return (
    <Box sx={{ px: 0.5, mt: -0.5 }}>
      {visibleSections.map((section) => (
        <Box key={section.category} sx={{ mb: 0.5 }}>
          {/* ■ カテゴリー */}
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 0.5,
              borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
            }}
          >
            <Box sx={{ fontSize: FONT_SIZE.XXS, fontWeight: 700 }}>■</Box>
            <Box sx={{ fontSize: FONT_SIZE.XXS, fontWeight: 700 }}>
              {section.category}
            </Box>
          </Box>

          {/* メインスキル */}
          {section.skills.map((skill) => (
            <Box key={`${section.category}-${skill.name}`}>
              {/* メインスキル名 */}
              <Box sx={{ fontSize: "0.65rem" }}>{skill.name}</Box>

              {/* サブスキル */}
              {skill.subSkills.length > 0 && (
                <Box
                  component="ul"
                  sx={{ m: 0, pl: 2, listStyleType: "disc" }}
                >
                  {skill.subSkills.map((subSkill) => (
                    <Box
                      key={`${section.category}-${skill.name}-${subSkill}`}
                      component="li"
                      sx={{
                        fontSize: FONT_SIZE.XXS,
                        lineHeight: 1.7,
                        whiteSpace: "pre-wrap",
                      }}
                    >
                      {subSkill}
                    </Box>
                  ))}
                </Box>
              )}
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  );
}
